/* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-disable class-methods-use-this */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { createFrame as createStripeThirdPartyFrame } from '@stripe-internal/stripethirdparty/no-ui';
import { Cookies } from '@stripe-internal/stripe-cookies';
const INPUT_TAGS = {
    checkLoaded: 'CHECK_PRIVACY_COMPLIANCE_LOADED'
};
const mountFrame = (config)=>createStripeThirdPartyFrame(config);
const asyncSleep = (intervalMillis)=>{
    return new Promise((resolve)=>{
        setTimeout(resolve, intervalMillis);
    });
};
const cookies = new Cookies();
export function attemptSetGoogleAnalyticsCookie(newGAValue) {
    const existingGAValue = cookies.get('_ga');
    if (newGAValue && newGAValue !== existingGAValue) {
        cookies.set('_ga', newGAValue);
    }
}
export class PrivacyComplianceProvider {
    ready() {
        var _this = this;
        return _async_to_generator(function*() {
            if (_this.readyPromise) {
                return _this.readyPromise;
            }
            _this.readyPromise = new Promise((resolve, _reject)=>{
                _this.iframeAccessorReady = false;
                const getPayload = function() {
                    var _ref = _async_to_generator(function*() {
                        if (!_this.stripeThirdPartyFrame) return false;
                        const { _ga } = yield _this.stripeThirdPartyFrame.sendRequest({
                            tag: INPUT_TAGS.checkLoaded
                        });
                        return {
                            _ga
                        };
                    });
                    return function getPayload() {
                        return _ref.apply(this, arguments);
                    };
                }();
                const waitForScriptAvailable = function() {
                    var _ref = _async_to_generator(function*() {
                        // 10 second timeout (check every 200ms up to 50 times)
                        const retryIntervalMillis = 200;
                        const totalRetries = 50;
                        // eslint-disable-next-line no-plusplus
                        for(let i = 0; i < totalRetries; i++){
                            // eslint-disable-next-line no-await-in-loop
                            const result = yield getPayload();
                            if (result && result._ga) {
                                return;
                            }
                            // eslint-disable-next-line no-await-in-loop
                            yield asyncSleep(retryIntervalMillis);
                        }
                    });
                    return function waitForScriptAvailable() {
                        return _ref.apply(this, arguments);
                    };
                }();
                _this.stripeThirdPartyFrame = mountFrame({
                    baseURL: _this.frameUrl,
                    type: 'PrivacyCompliance',
                    onReady: function() {
                        var _ref = _async_to_generator(function*(_sendMessage) {
                            yield waitForScriptAvailable();
                            // If we get here, the script was either able to load a value for _ga,
                            // or it timed out. If there was no value, then it's assumed _ga was
                            // not set in the iframe.
                            const result = yield getPayload();
                            if (result && result._ga) {
                                attemptSetGoogleAnalyticsCookie(result._ga);
                            }
                        });
                        return function(_sendMessage) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    frameAttributes: {
                        class: 'ThirdPartyFrame'
                    }
                });
                document.body.appendChild(_this.stripeThirdPartyFrame.frame);
                // Mark the provider as ready once the iframe accessor is available, even
                // if the value isn't loaded yet.
                _this.iframeAccessorReady = true;
                resolve(true);
            });
            return _this.readyPromise;
        })();
    }
    // These methods are required by the TrackingProvider interface but are not
    // used by the PrivacyComplianceProvider since this provider doesn't actually
    // track anything.
    setExperimentTreatment() {
        return _async_to_generator(function*() {})();
    }
    trackPage() {
        return _async_to_generator(function*() {})();
    }
    trackEvent() {
        return _async_to_generator(function*() {})();
    }
    trackVitals() {
        return _async_to_generator(function*() {})();
    }
    constructor(frameUrl){
        _define_property(this, "iframeAccessorReady", false);
        _define_property(this, "stripeThirdPartyFrame", null);
        _define_property(this, "frameUrl", void 0);
        _define_property(this, "readyPromise", null);
        this.frameUrl = frameUrl;
    }
}

//# sourceMappingURL=PrivacyCompliance.js.map